import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import Button from './Button';

const ConfirmDialog = ({
  title = 'Bist du sicher?',
  message,
  confirmLabel = 'Löschen',
  cancelLabel = 'Abbrechen',
  destructive = true,
  onConfirm,
  onCancel
}) => (
  <div
    className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-[70]"
    onClick={(e) => { e.stopPropagation(); onCancel(); }}
  >
    <div
      className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-5 space-y-4"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${
          destructive ? 'bg-red-50 text-red-500' : 'bg-primary-50 text-primary-600'
        }`}>
          <AlertTriangle size={20} />
        </div>
        <div className="flex-1 min-w-0 pt-1">
          <h3 className="text-sm font-bold text-neutral-800">{title}</h3>
          {message && <p className="text-sm text-neutral-500 mt-1">{message}</p>}
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="p-1 text-neutral-400 hover:text-neutral-700 hover:bg-neutral-100 rounded-lg transition-all flex-shrink-0"
        >
          <X size={16} />
        </button>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 py-2 px-4 rounded-xl font-semibold text-sm text-neutral-500 border border-neutral-200 hover:bg-neutral-100 transition-all"
        >
          {cancelLabel}
        </button>
        <Button
          type="button"
          onClick={onConfirm}
          variant={destructive ? 'danger' : 'primary'}
          className="flex-1 py-2 px-4 text-sm"
        >
          {confirmLabel}
        </Button>
      </div>
    </div>
  </div>
);

export default ConfirmDialog;
